



























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class VerticalAlignTop extends Vue {
    @Prop() private userConfigColor! : string;
}
